import { render, staticRenderFns } from "./team-members.vue?vue&type=template&id=40f6e9cc&scoped=true&"
import script from "./team-members.vue?vue&type=script&lang=js&"
export * from "./team-members.vue?vue&type=script&lang=js&"
import style0 from "./team-members.vue?vue&type=style&index=0&id=40f6e9cc&scoped=true&lang=scss&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "40f6e9cc",
  null
  
)

component.options.__file = "team-members.vue"
export default component.exports